<div class="input relative w-full">
  @if (icon) {
    <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
      <fa-icon [icon]="icon"></fa-icon>
    </div>
  }
  <input
    [type]="type"
    [value]="value"
    [disabled]="disabled"
    (input)="updateValue($event)"
    (blur)="onTouched()"
    class="focus:border-le-blue-300 w-full border-b-2 border-gray-300 bg-transparent py-2 pr-3 placeholder:text-sm focus:outline-none dark:border-gray-600"
    [placeholder]="placeholder"
    [class]="[icon ? 'pl-10' : 'pl-3']"
  />
</div>
